class OrderTracking extends window.BAO.CustomElement() {
  static get requiredElements() {
    return ["tracking-numbers", "tracking-company", "tracking-widget", "form"];
  }

  connectedCallback() {
    this.retailer = this.dataset.retailer;
    this.localeLanguage = this.dataset.localeLanguage;
    this.localeCountry = this.dataset.localeCountry;
    this.queryParams = this.getQueryParams();

    this.populateFormData();

    if (
      this.queryParams.tracking_numbers != null &&
      this.queryParams.tracking_company != null
    ) {
      this.loadWidget(
        this.queryParams.tracking_numbers,
        this.queryParams.tracking_company,
      );
    }

    this.listeners.add(
      this.els.form.element,
      "submit",
      this.handleFormSubmit.bind(this),
    );
  }

  getQueryParams() {
    const queryParams = new URLSearchParams(window.location.search);
    return Object.fromEntries(queryParams.entries());
  }

  handleFormSubmit(e) {
    e.preventDefault();

    const trackingNumber = this.els["tracking-numbers"].element?.value;
    const trackingCompany = this.els["tracking-company"].element?.value;

    if (trackingNumber && trackingCompany) {
      this.reloadWithNewParams(trackingNumber, trackingCompany);
    }
  }

  reloadWithNewParams(trackingNumbers, trackingCompany) {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    params.has("tracking_numbers")
      ? params.set("tracking_numbers", trackingNumbers)
      : params.append("tracking_numbers", trackingNumbers);
    params.has("tracking_company")
      ? params.set("tracking_company", trackingCompany)
      : params.append("tracking_company", trackingCompany);

    url.search = params.toString();
    const newUrl = url.toString();

    window.location.href = newUrl;
  }

  populateFormData() {
    if (this.queryParams.tracking_numbers) {
      this.els["tracking-numbers"].element.value =
        this.queryParams.tracking_numbers;
    }

    if (this.queryParams.tracking_company) {
      this.els["tracking-company"].element.value =
        this.queryParams.tracking_company;
    }
  }

  loadWidget(trackingNumbers, trackingCompany) {
    try {
      const queryParameters = window.location.search
        .replace(/^\?/g, "")
        .split("&")
        .reduce((acc, param) => {
          const keyAndValue = param.split("=");
          acc[keyAndValue[0]] = keyAndValue[1];
          return acc;
        }, {});
      window.narvar("track", {
        retailer: this.retailer,
        locale_language: this.localeLanguage,
        locale_country: this.localeLanguage,
        tracking_numbers: trackingNumbers,
        carrier: trackingCompany,
        order_number: this.queryParams.order_number
          ? this.queryParams.order_number
          : "",
        t: queryParameters.t,
        ...queryParameters,
      });

      this.els.form.element.setAttribute("aria-hidden", true);
      this.els["tracking-widget"].element.setAttribute("aria-hidden", false);
    } catch (err) {
      console.error(err);
    }
  }
}

if (!customElements.get("order-tracking")) {
  customElements.define("order-tracking", OrderTracking);
}
